<template>
  <div>
     <MzInputRadioGroup
      inline
      custom
      class="mb-3"
      :options="radioOptions"
      :checked.sync="selectedView"
    />
    <tableComponent
      :data="statistics"
      :columns="tableColumns"
      :headings="tableHeadings"
      :key="refreshTable"
      class="stats-table"
      :filter-exclude-columns="['actions']"
      :sort-exclude-columns="['actions']"
      :show-top-number-of-records="false"
      :display-columns-selector="false"
      :hidden-columns="['nb_noanswer']"
      :not-formatted-columns="['nb_alumni', 'p_completed', 'p_unsub']"
    >
      <template slot="p_completed" slot-scope="{ row }">
        {{ row.p_completed || '0' }}%
      </template>
      <template slot="p_unsub" slot-scope="{ row }">
        {{row.p_unsub || '0'}}%
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-block" style="row-gap: 0.25em; column-gap: 0.5em">
          <CButton
            class="sm outline action-button d-flex flex-row align-items-center"
            color="primary"
            size="sm"
            variant="outline"
            style="min-width: 190px"
            @click="() =>
              downloadFile({
                downloadURL: `${BASE_URL}api/statistics/export/${$route.params.campaign_id}/`,
                query: {
                  aggregate_per: selectedView,
                  value: selectedView === 'certification_code' ? row.certification_code : row.ecole,
                },
            })"
          >
            <em class="fa fa-upload"/>
            <span class="ml-1">
              Exporter les non répondants
            </span>
          </CButton>
        </div>
      </template>
    </tableComponent>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";
import {CampaignMixin} from "@/mixins/campaignMixin";
import { request, downloadFile } from "@/utils/request";

export default {
    name: "CampaignStats",
    mixins: {CampaignMixin},
    data() {
      return {
        radioOptions: [
          {label: "Ecoles", value: "ecole"},
          {label: "Titres / diplômes", value: "certification_code"},
        ],
          selectedView: "ecole",
          BASE_URL,
          statistics: [],
          refreshTable: 0,
          tableHeadings: {
              "ecole": "Ecole",
              "certification_code": "Certification Code",
              "certification_name": "Certification Name",
              "nb_alumni": "Nombre d'alumnis",
              "nb_noanswer": "Nombre de non répondants",
              "p_completed": "Taux de répondants",
              "p_unsub": "Taux de désinscrits",
          },
      }
    },
    async mounted() {
      this.statistics = await this.fetchStats(this.selectedView);
    },
    watch: {
      async selectedView(newVal) {
        this.statistics = await this.fetchStats(newVal);
      },
    },
    computed: {
      tableColumns() {
        const tableColumns = [
          "nb_alumni",
          "nb_noanswer",
          "p_completed",
          "p_unsub",
          "actions"
        ]
        if (this.selectedView === "certification_code") {
          return [...["certification_code",
          "certification_name"], ...tableColumns]
        } else return [...["ecole"], ...tableColumns]
      }
    },
    methods: {
      downloadFile,
      async fetchStats(filter_by) {
          const { data } = await request({
            url: `${BASE_URL}api/statistics/${(this.campaignId || this.$route.params.campaign_id)}/`,
            query: {
              filter_by
            }
          });
          return data
      }
    }
}
</script>

<style lang="scss">
.stats-table {
  .VueTables__p_completed-filter-wrapper {
    width: 100%;
  }
  .VueTables__p_completed-filter-wrapper div {
    width: 100%;
  }
  .VueTables__p_unsub-filter-wrapper {
    width: 100%;
  }
  .VueTables__p_unsub-filter-wrapper div {
    width: 100%;
  }
  .VueTables__nb_alumni-filter-wrapper {
    width: 100%;
  }
  .VueTables__nb_alumni-filter-wrapper div {
    width: 100%;
  }
}
.custom-radio .custom-control-label {
  color: #3C4b64 !important;
}

</style>
